<template>
    <div>
        <!-- mensajes de alerta -->
        <v-alert prominent :value="mostrar_alert" text dense :type="tipo_alert">
            <v-row align="center">
                <v-col class="grow">{{ mensaje_alert }}</v-col>
                <v-col class="shrink">
                    <v-btn icon @click="cerrar_alert"><v-icon>highlight_off</v-icon></v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <!-- mensajes de alerta -->

        <!-- mensaje de prorrateo -->
        <v-alert border="top" v-if="registros_prorrateados.length > 0" colored-border type="info" elevation="2">
            <v-row>
                <v-col>Se setearon Los siguientes valores de manera automática!</v-col>
                <v-col class="text-right"><v-btn @click="borrarRegistrosProrrateados()" icon
                        color='blue darken-1'><v-icon>cancel</v-icon></v-btn></v-col>
            </v-row>

            <v-card>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Hora</th>
                            <th class="text-center">Parámetro</th>
                            <th class="text-center">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="r in registros_prorrateados" :key="r.id">
                            <td class="text-center">{{ r.fecha }}</td>
                            <td class="text-center">{{ r.hora }}</td>
                            <td class="text-center">{{ r.parametro }}</td>
                            <td class="text-center">{{ r.valor }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card>

        </v-alert>
        <!-- mensaje de prorrateo -->


        <!-- tabla 3 -->

        <v-card>
            <v-card-text>
                <div class="table-box">
                    <table>
                        <thead>
                            <!-- fila de titulos -->
                            <tr>
                                <!-- titulos de columnas_inicio -->
                                <th v-for="columna in ajustes.columnas_inicio" :key="columna.key"
                                    :colspan="columna.colspan"
                                    v-bind:class="{ 'header-0': columna.titulo_visible, 'border': columna.titulo_visible }">
                                    {{ columna.titulo }}</th>
                                <!-- titulos de columnas_inicio -->


                                <!-- generando el titulo por cada tipo de equipo -->
                                <th class="text-center" v-for="tipo in ajustes.tipos" :key="tipo.tipo_equipo_id"
                                    :colspan="tipo.colspan"
                                    v-bind:class="{ 'header-0': tipo.visible, 'border': tipo.visible }">{{
                                        tipo.tipo_equipo }}
                                </th>
                                <!-- generando el titulo por cada tipo de equipo -->

                                <!-- titulos de columnas_final -->
                                <th v-for="columna in ajustes.columnas_final" :key="columna.key"
                                    :colspan="columna.colspan"
                                    v-bind:class="{ 'header-0': columna.titulo_visible, 'border': columna.titulo_visible }">
                                    {{ columna.titulo }}</th>
                                <!-- titulos de columnas_final -->

                            </tr>
                            <!-- fila de titulos -->

                            <!-- segunda fila de cabecera de equipos -->
                            <tr>

                                <!-- columnas_inicio -->
                                <th :class="[{ 'hidden': columna.colspan == 0 }]" :colspan="columna.colspan"
                                    :rowspan="columna.rowspan" v-for="columna in ajustes.columnas_inicio"
                                    :key="columna.key" class="text-center border header-1 z-index-header"
                                    :style="`min-width:${columna.tamanio ? columna.tamanio : ''}`">
                                    {{ columna.cabecera }}
                                </th>
                                <!-- columnas_inicio -->

                                <!-- equipos -->
                                <th :class="[{ 'hidden': columna.colspan == 0 }]" :colspan="columna.colspan"
                                    v-for="columna in obtenerEquipos" :key="columna.key"
                                    class="text-center border header-1 z-index-header">
                                    {{ columna.cabecera }}
                                </th>
                                <!-- equipos -->

                                <!-- columnas_final -->
                                <th :class="[{ 'hidden': columna.colspan == 0 }]" :colspan="columna.colspan"
                                    :rowspan="columna.rowspan" v-for="columna in ajustes.columnas_final"
                                    :key="columna.key" class="text-center border header-1 z-index-header">
                                    {{ columna.cabecera }}
                                </th>
                                <!-- columnas_final -->


                                <!-- header acciones -->
                                <!-- <th class="text-center border header-1 z-index-header" :colspan="settings2.actions.length">

                                </th> -->
                                <!-- header acciones -->

                            </tr>
                            <!-- segunda fila de cabecera de equipos -->


                            <!-- tercera fila de parámetros -->
                            <tr>
                                <!-- subcolumnas de columnas_inicio -->
                                <th v-bind:class="{ 'hidden': !subcolumna.visible, 'z-index-1': subcolumna.fixed == 1, 'z-index-2': subcolumna.fixed == 2, 'z-index-3': subcolumna.fixed == 3, 'z-index-header': subcolumna.fixed == 0 }"
                                    v-for="subcolumna in obtenerSubColumnasInicio" :key="subcolumna.cabecera"
                                    class="text-center border header-2">
                                    {{ subcolumna.cabecera }}
                                </th>
                                <!-- subcolumnas de columnas_inicio -->


                                <!-- subcolumnas de parametros -->
                                <th v-bind:class="{ 'hidden': !parametro.visible, 'z-index-1': parametro.fixed == 1, 'z-index-2': parametro.fixed == 2, 'z-index-3': parametro.fixed == 3, 'z-index-header': parametro.fixed == 0 }"
                                    v-for="parametro in obtenerParametros" :key="parametro.id"
                                    class="text-center border header-2">
                                    <!-- <span v-if="sub_column.visible">
                                                    {{sub_column.header}}
                                                </span> -->
                                    {{ parametro.nombre_parametro }}<br>
                                    <span v-if="parametro.unidad_medida != '.'">
                                        ({{ parametro.unidad_medida }})
                                    </span>
                                </th>
                                <!-- subcolumnas de parametros -->

                                <!-- subcolumnas de columnas_final -->
                                <th v-bind:class="{ 'hidden': !subcolumna.visible, 'z-index-1': subcolumna.fixed == 1, 'z-index-2': subcolumna.fixed == 2, 'z-index-3': subcolumna.fixed == 3, 'z-index-header': subcolumna.fixed == 0 }"
                                    v-for="subcolumna in obtenerSubColumnasFinal" :key="subcolumna.cabecera"
                                    class="text-center border header-2">
                                    {{ subcolumna.cabecera }}
                                </th>
                                <!-- subcolumnas de columnas_final -->

                                <!-- acciones -->
                                <!-- <th class="text-center border header-2 z-index-header" v-for="action in ajustes.acciones" :key="action.key">
                                        <span v-if="action.visible">
                                            {{action.header}}
                                        </span>
                                    </th> -->
                                <!-- acciones -->
                            </tr>
                            <!-- tercera fila de parámetros -->
                        </thead>
                        <tbody>
                            <!-- nuevos registros -->
                            <tr v-for="(registro, idx) in nuevosRegistrosFormulasCalculadas" :key="registro.id"
                                :class="`barridos-${registro.barrido == true ? 1 : 0}`">
                                <!-- subcolumnas de columnas_inicio -->
                                <td :style="getColor(registro.color, subcolumna)" class="text-center"
                                    v-bind:class="{ 'hidden': !subcolumna.visible, 'fixed-left-1': subcolumna.fixed == 1, 'fixed-left-2': subcolumna.fixed == 2, 'fixed-left-3': subcolumna.fixed == 3 }"
                                    v-for="subcolumna in obtenerSubColumnasInicio" :key="subcolumna.key">

                                    <v-select v-if="subcolumna.tipo == 'select'" v-model="registro[subcolumna.key]"
                                        :items="subcolumna.opciones" :item-text="subcolumna.texto"
                                        :item-value="subcolumna.seleccion" :label="subcolumna.label"
                                        :disabled="editables || registro.vobo" color="blue darken-3" persistent-hint
                                        return-object single-line dense
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna)"></v-select>

                                    <v-autocomplete v-if="subcolumna.tipo == 'autocomplete'"
                                        v-model="registro[subcolumna.key]" :items="subcolumna.opciones"
                                        :item-text="subcolumna.texto" :item-value="subcolumna.seleccion"
                                        :label="subcolumna.label" :disabled="editables || registro.vobo"
                                        color="blue darken-3" style="min-width:130px;" dense
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna)"></v-autocomplete>

                                    <v-switch v-if="subcolumna.tipo == 'radio'" v-model="registro[subcolumna.key]"
                                        :disabled="editables || registro.vobo" :title="subcolumna.title"
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna)"></v-switch>


                                    <input v-if="subcolumna.tipo == 'texto'" type="text"
                                        :disabled="editables || registro.vobo" v-model="registro[subcolumna.key]"
                                        v-bind:class="[{ 'limite_alto': subcolumna.key == 'nombre_lote' && restriccion(registro['nombre_lote']) }, { 'fuente': subcolumna.key != 'fecha' && subcolumna.key != 'hora' }]"
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna, 'subcolumna_inicio')">

                                    <label for="" v-if="subcolumna.tipo == 'label'">{{ registro[subcolumna.key]
                                    }}</label>

                                    <!-- boton para agregar comentarios -->
                                    <v-btn v-if="subcolumna.tipo == 'comentario'" :disabled="editables || registro.vobo"
                                        icon @click="abrirModalComentario(registro, 'resultado_analisis')">
                                        <v-icon v-if="registro.observacion == null || registro.observacion == ''"
                                            color="blue-grey lighten-4">insert_comment</v-icon>
                                        <v-icon v-if="registro.observacion != null && registro.observacion != ''"
                                            color="orange darken-4">insert_comment</v-icon>
                                        <v-icon v-if="registro.vobo" color="orange darken-4">lock</v-icon>
                                    </v-btn>
                                    <!-- boton para agregar comentarios -->

                                    <!-- agregando boton asignar jumbo -->
                                    <v-btn fab dark x-small color="blue darken-3" :disabled="editables || registro.vobo"
                                        v-if="subcolumna.key == 'asignar_jumbo' && registro['nombre_lote'] == ''"
                                        @click="asignar_jumbo(registro, 'crear')"><v-icon>add_box</v-icon></v-btn>
                                    <v-btn fab dark x-small color="orange darken-3"
                                        :disabled="editables || registro.vobo"
                                        v-if="subcolumna.key == 'asignar_jumbo' && registro['nombre_lote'] != ''"
                                        @click="asignar_jumbo(registro, 'editar')"><v-icon>edit</v-icon></v-btn>
                                    <!-- agregando boton asignar jumbo -->

                                    <!-- agregado para mostrar el detalle de un jumbo -->
                                    <v-tooltip v-if="subcolumna.key == 'nro_jumbo' && registro.proviene_de != null" top
                                        color="blue darken-4">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon color="blue darken-1">info</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ `Proviene de: ${registro.proviene_de.texto}` }}</span>
                                    </v-tooltip>
                                    <!-- agregado para mostrar el reproceso de un jumbo que se carga en los movimeintos-->
                                    <v-tooltip v-if="subcolumna.key == 'nro_jumbo' && registro.movimiento != null" top
                                        color="orange darken-4">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon color="blue darken-1">info</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ `Reproceso - Movimiento N° ${registro.movimiento} Fecha:
                                            ${registro.movimiento_fecha}` }}</span>
                                    </v-tooltip>


                                    <v-btn v-if="subcolumna.key == 'nro_jumbo' && registro.jumbos_id == null"
                                        :disabled="lock_rayo" top color="white"
                                        title="Asignar numeración según correlativo anterior"
                                        @click="asignar_rapido(registro)">
                                        <v-icon> bolt </v-icon>
                                    </v-btn>

                                    <!-- agregado para mostrar el detalle de un jumbo -->
                                </td>
                                <!-- subcolumnas de columnas_inicio -->

                                <!-- parametros -->
                                <td :style="getColor(registro.color, null)" v-bind:class="{ 'text-center': true }"
                                    v-for="parametro in obtenerParametros" :key="parametro.id">

                                    <!-- parametro de tipo numero -->
                                    <input :disabled="editables || registro.vobo" :attr="editables || registro.vobo"
                                        :ref="`nuevo${idx}${parametro.id}`" v-if="parametro.tipo == 'numero'"
                                        :min="parametro.valor_minimo ? parametro.valor_minimo : 0"
                                        v-bind:class="[marcar_color_optimo(parametro, registro) ? 'color_optimo' : '', marcar_color_optimo_maximo(parametro, registro, idx) ? 'color_alarma' : '', registro[parametro.id].numero_alarmas > 0 ? 'color_alarma' : '', 'fuente']"
                                        type="number" v-model="registro[parametro.id].valor"
                                        @change="registrar_detalle(`nuevo${idx}${parametro.id}`, registro, parametro, 'parametro')">
                                    <!-- parametro de tipo numero -->

                                    <!-- parametro de tipo select -->
                                    <v-select v-if="parametro.tipo == 'select'" :items="parametro.opciones"
                                        item-text="opcion" item-value="id" :disabled="editables || registro.vobo"
                                        v-model="registro[parametro.id].valor"
                                        @change="registrar_detalle_select(registro, parametro)" dense></v-select>
                                    <!-- parametro de tipo select -->

                                    <!-- boton para agregar comentarios -->
                                    <v-btn v-if="registro[parametro.id].id != '' && parametro.tipo != 'select'" icon
                                        @click="abrirModalComentario(registro, parametro)">
                                        <v-icon
                                            v-if="registro[parametro.id].observacion == null || registro[parametro.id].observacion == ''"
                                            color="blue-grey lighten-4">insert_comment</v-icon>
                                        <v-icon
                                            v-if="registro[parametro.id].observacion != null && registro[parametro.id].observacion != ''"
                                            color="orange darken-4">insert_comment</v-icon>
                                    </v-btn>
                                    <!-- boton para agregar comentarios -->

                                </td>
                                <!-- parametros -->

                                <!-- subcolumnas de columnas_final -->
                                <td :style="getColor(registro.color, subcolumna)" class="text-center"
                                    v-bind:class="{ 'hidden': !subcolumna.visible, 'fixed-left-1': subcolumna.fixed == 1, 'fixed-left-2': subcolumna.fixed == 2, 'fixed-left-3': subcolumna.fixed == 3 }"
                                    v-for="subcolumna in obtenerSubColumnasFinal" :key="subcolumna.key">
                                    <v-select v-if="subcolumna.tipo == 'select'" v-model="registro[subcolumna.key]"
                                        :items="subcolumna.opciones" :item-text="subcolumna.texto"
                                        :item-value="subcolumna.seleccion" :label="subcolumna.label"
                                        :disabled="editables || registro.vobo" color="blue darken-3" persistent-hint
                                        return-object single-line dense
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna)"></v-select>
                                    <input v-if="subcolumna.tipo == 'texto'" :disabled="editables || registro.vobo"
                                        type="text" v-model="registro[subcolumna.key]"
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna, 'subcolumna_inicio')">

                                    <!-- boton para marcar un registro de color -->
                                    <v-btn fab dark small color="amber darken-3" v-if="subcolumna.key == 'marcar'"
                                        @click="marcar_color(registro)"><v-icon>colorize</v-icon></v-btn>
                                </td>
                                <!-- subcolumnas de columnas_final -->

                            </tr>
                            <!-- nuevos registros -->


                            <!-- fila ploma separadora -->
                            <tr class="fila_separadora">
                                <td class="fila_separadora" :colspan="numeroSubColumnas"></td>
                            </tr>
                            <!-- fila ploma separadora -->


                            <!-- ultimos registros -->
                            <tr v-for="(registro, idx) in ultimosRegistrosFormulasCalculadas" :key="registro.id"
                                :class="`barridos-${registro.barrido == true ? 1 : 0}`">

                                <!-- subcolumnas de columnas_inicio -->
                                <!-- <td class="border text-center" v-bind:class="{'td_con_icono':subcolumna.key=='nro_jumbo','hidden': !subcolumna.visible,'fixed-left-1':subcolumna.fixed == 1,'fixed-left-2':subcolumna.fixed == 2,'fixed-left-3':subcolumna.fixed == 3}" v-for="subcolumna in obtenerSubColumnasInicio" :key="subcolumna.key"> -->
                                <td class="text-center" :style="getColor(registro.color, subcolumna)"
                                    v-bind:class="{ 'hidden': !subcolumna.visible, 'fixed-left-1': subcolumna.fixed == 1, 'fixed-left-2': subcolumna.fixed == 2, 'fixed-left-3': subcolumna.fixed == 3 }"
                                    v-for="subcolumna in obtenerSubColumnasInicio" :key="subcolumna.key">

                                    <v-select v-if="subcolumna.tipo == 'select'" v-model="registro[subcolumna.key]"
                                        :items="subcolumna.opciones" :item-text="subcolumna.texto"
                                        :item-value="subcolumna.seleccion" :label="subcolumna.label"
                                        :disabled="editables || registro.vobo" color="blue darken-3" persistent-hint
                                        return-object single-line dense
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna)"></v-select>

                                    <v-autocomplete v-if="subcolumna.tipo == 'autocomplete'"
                                        v-model="registro[subcolumna.key]" :items="subcolumna.opciones"
                                        :item-text="subcolumna.texto" :item-value="subcolumna.seleccion"
                                        :label="subcolumna.label" :disabled="editables || registro.vobo"
                                        style="min-width:130px" color="blue darken-3" dense
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna)"></v-autocomplete>

                                    <v-switch v-if="subcolumna.tipo == 'radio'" v-model="registro[subcolumna.key]"
                                        :disabled="editables || registro.vobo" :title="subcolumna.title"
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna)"></v-switch>

                                    <input :disabled="editables || registro.vobo" :readonly="subcolumna.solo_lectura"
                                        v-if="subcolumna.tipo == 'texto'" type="text"
                                        v-bind:class="[{ 'limite_alto': subcolumna.key == 'nombre_lote' && restriccion(registro['nombre_lote']) }, { 'fuente': subcolumna.key != 'fecha' && subcolumna.key != 'hora' }]"
                                        v-model="registro[subcolumna.key]"
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna, 'subcolumna_inicio')">

                                    <label for="" v-if="subcolumna.tipo == 'label'">{{ registro[subcolumna.key]
                                    }}</label>

                                    <!-- boton para agregar comentarios -->
                                    <v-btn v-if="subcolumna.tipo == 'comentario'" icon
                                        @click="abrirModalComentario(registro, 'resultado_analisis')">
                                        <v-icon v-if="registro.observacion == null || registro.observacion == ''"
                                            color="blue-grey lighten-4">insert_comment</v-icon>
                                        <v-icon v-if="registro.observacion != null && registro.observacion != ''"
                                            color="orange darken-4">insert_comment</v-icon>
                                        <v-icon v-if="registro.vobo" color="orange darken-4">lock</v-icon>
                                    </v-btn>
                                    <!-- boton para agregar comentarios -->

                                    <!-- agregando boton asignar jumbo -->
                                    <v-btn fab dark x-small color="blue darken-3" :disabled="editables || registro.vobo"
                                        v-if="subcolumna.key == 'asignar_jumbo' && registro['nombre_lote'] == ''"
                                        @click="asignar_jumbo(registro, 'crear')"><v-icon>add_box</v-icon></v-btn>
                                    <v-btn fab dark x-small color="orange darken-4"
                                        :disabled="editables || registro.vobo"
                                        v-if="subcolumna.key == 'asignar_jumbo' && registro['nombre_lote'] != ''"
                                        @click="asignar_jumbo(registro, 'editar')"><v-icon>edit</v-icon></v-btn>
                                    <!-- agregando boton asignar jumbo -->

                                    <!-- agregado para mostrar el detalle de un jumbo -->

                                    <v-tooltip top color="blue darken-4"
                                        v-if="subcolumna.key == 'nro_jumbo' && registro.proviene_de != null">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon color="blue darken-1">info</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ `Proviene de: ${registro.proviene_de.texto}` }}</span>
                                    </v-tooltip>
                                    <v-tooltip top color="orange darken-3"
                                        v-if="subcolumna.key == 'nro_jumbo' && registro.movimiento != null">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon color="orange darken-1">info</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ `Reproceso - Movimiento N° ${registro.movimiento} Fecha:
                                            ${registro.movimiento_fecha}` }}</span>
                                    </v-tooltip>
                                    <v-btn v-if="subcolumna.key == 'nro_jumbo' && registro.jumbos_id == null"
                                        :disabled="lock_rayo" top color="white"
                                        title="Asignar numeración según correlativo anterior"
                                        @click="asignar_rapido(registro)">
                                        <v-icon> bolt </v-icon>
                                    </v-btn>
                                    <!-- agregado para mostrar el detalle de un jumbo -->

                                </td>
                                <!-- subcolumnas de columnas_inicio -->

                                <!-- parametros -->
                                <td style="white-space:nowrap;" :style="getColor(registro.color, null)"
                                    class="text-center" v-for="parametro in obtenerParametros" :key="parametro.id">
                                    <!-- <input type="hidden" :value="valorFormulas"> -->
                                    <!-- <input v-bind:class="[registro[parametro.id].valor != '' && registro[parametro.id].valor >= parametro.limite_max && parametro.limite_max!=null? 'limite_alto' : '',registro[parametro.id].valor <= parametro.limite_min &&parametro.limite_min!=null && registro[parametro.id].valor != ''?'limite_bajo':'']" type="number" step="any" v-model="registro[parametro.id].valor" @change="registrar_detalle(registro,parametro,'parametro')"> -->

                                    <!-- parametro de tipo numero -->
                                    <input :ref="`old${idx}${parametro.id}`" :disabled="editables || registro.vobo"
                                        v-if="parametro.tipo == 'numero'"
                                        :min="parametro.valor_minimo ? parametro.valor_minimo : 0"
                                        :max="parametro.valor_maximo ? parametro.valor_maximo : 200"
                                        v-bind:class="[marcar_color_optimo(parametro, registro, idx) ? 'color_optimo' : '', marcar_color_optimo_maximo(parametro, registro, idx) ? 'color_alarma' : '', registro[parametro.id].numero_alarmas > 0 ? 'color_alarma' : '', 'fuente']"
                                        type="number" v-model="registro[parametro.id].valor"
                                        @change="registrar_detalle(`old${idx}${parametro.id}`, registro, parametro, 'parametro')">
                                    <!-- parametro de tipo numero -->

                                    <!-- parametro de tipo select -->
                                    <v-select v-if="parametro.tipo == 'select'" :items="parametro.opciones"
                                        :disabled="editables || registro.vobo" item-text="opcion" item-value="id"
                                        v-model="registro[parametro.id].valor" dense
                                        @change="registrar_detalle_select(registro, parametro)"></v-select>
                                    <!-- parametro de tipo select -->

                                    <!-- boton para agregar comentarios -->
                                    <v-btn v-if="registro[parametro.id].id != '' && parametro.tipo != 'select'" icon
                                        @click="abrirModalComentario(registro, parametro)">
                                        <v-icon
                                            v-if="registro[parametro.id].observacion == null || registro[parametro.id].observacion == ''"
                                            color="blue-grey lighten-4">insert_comment</v-icon>
                                        <v-icon
                                            v-if="registro[parametro.id].observacion != null && registro[parametro.id].observacion != ''"
                                            color="orange darken-4">insert_comment</v-icon>
                                    </v-btn>
                                    <!-- boton para agregar comentarios -->

                                </td>
                                <!-- parametros -->

                                <!-- subcolumnas de columnas_final -->
                                <td :style="getColor(registro.color, subcolumna)" class="text-center"
                                    v-bind:class="{ 'hidden': !subcolumna.visible, 'fixed-left-1': subcolumna.fixed == 1, 'fixed-left-2': subcolumna.fixed == 2, 'fixed-left-3': subcolumna.fixed == 3 }"
                                    v-for="subcolumna in obtenerSubColumnasFinal" :key="subcolumna.key">
                                    <v-select v-if="subcolumna.tipo == 'select'" v-model="registro[subcolumna.key]"
                                        :items="subcolumna.opciones" :item-text="subcolumna.texto"
                                        :item-value="subcolumna.seleccion" :label="subcolumna.label"
                                        :disabled="editables || registro.vobo" color="blue darken-3" persistent-hint
                                        return-object single-line dense
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna)"></v-select>
                                    <input v-if="subcolumna.tipo == 'texto'" :disabled="editables || registro.vobo"
                                        type="text" v-model="registro[subcolumna.key]"
                                        @change="guardarColumnaResultadoAnalisis(registro, subcolumna, 'subcolumna_inicio')">

                                    <!-- boton para marcar un registro de color -->
                                    <v-btn fab dark x-small color="amber darken-3" v-if="subcolumna.key == 'marcar'"
                                        @click="marcar_color(registro)"><v-icon>colorize</v-icon></v-btn>
                                </td>
                                <!-- subcolumnas de columnas_final -->

                            </tr>
                            <!-- ultimos registros -->

                        </tbody>
                    </table>
                </div>
            </v-card-text>
        </v-card>
        <!-- tabla 3 -->

        <!-- modal para crear jumbo -->
        <modal-jumbo></modal-jumbo>
        <!-- modal para crear jumbo -->

        <!-- modal para aplicar color -->
        <modal-color></modal-color>
        <!-- modal para aplicar color -->

        <!-- modal para comentario de parametro -->
        <modal-comentario-parametro @actualizar_comentario_parametro="actualizar_comentario($event)"
            @observacion_actualizada="actualizar_comentario_analisis($event)"></modal-comentario-parametro>
        <!-- modal para comentario de parametro -->

        <!-- modal confirmacion -->
        <confirm ref="confirm"></confirm>
        <!-- modal confirmacion -->


    </div>
</template>
<script>
// import axios from 'axios'
import { mapState, mapMutations } from 'vuex';
import Modal_Jumbo from '@/components/shared/Modal_Jumbo.vue';
import Modal_Seleccion_Color from '@/components/shared/Modal_Seleccion_Color.vue';
import Modal_Comentario_Parametro from './Modal_Comentario_Parametro.vue';
import Confirm from './Confirm.vue';
export default {
    data: () => ({
        mostrar_alert: false,
        es_prod: true,
        lock_rayo: false,
        tipo_alert: 'info',
        mensaje_alert: '',
        punto_medicion: '',
        punto_medicion_id: '',
        ajustes: {
            columnas_inicio: [],
            tipos: [],
            columnas_final: [],
        },
        registros: [],
        ultimos_registros: [],
        ultimos_registros_recibidos: [],
        registros_prorrateados: []
    }),
    beforeDestroy() {
        /**Elimina la subscripcion a los eventos cuando el componente tabla_registro es destruido */
        Event.$off('crear_tabla');
        Event.$off('agregar_fila');
        Event.$off('nuevo_jumbo');
        Event.$off('actualizar_jumbo');
        Event.$off('lote_creado');
        Event.$off('cambiar_color');
        Event.$off('actualizar_comentario');
    },
    mounted() {
        Event.$on('cambiar_color', (registro) => {
            this.actualizar_color(registro);
        });
        Event.$on('crear_tabla', (ajustes, ultimos_registros, punto_medicion) => {
            this.registros = [];
            this.ultimos_registros = [];
            this.ultimos_registros_recibidos = [];
            this.punto_medicion = punto_medicion;

            this.ultimos_registros_recibidos = ultimos_registros;
            this.ajustes = ajustes;
            this.rellenarUltimosRegistros();
            // ////console.log('ajustes_recibidos',this.ajustes);
            // ////console.log('ultimos_registros_recibidos',this.ultimos_registros_recibidos);
        });
        Event.$on('agregar_fila', async (tipo) => {
            //  ////console.log('event was triggered');
            // ////console.log('fila de tipo de punto a agregar',tipo);
            this.punto_medicion_id = tipo.punto_medicion_id;
            if (tipo.tipo == 'jumbo') {
                await this.crear_jumbo();
            } else {
                this.agregarFila();
            }
            // if(tipo!=undefined){
            //     if(tipo.tipo == 'jumbo'){

            //         // se esta agregando un jumbo
            //         await this.crear_jumbo();
            //         //abrir modal para indicar el lote y numero de jumbo
            //         // Event.$emit('abrir_modal_jumbo');
            //     }
            // }else{
            //         this.agregarFila();
            // }
        });

        //se utiliza cuando se crea un nuevo jumbo
        Event.$on('nuevo_jumbo', async (jumbo, registro) => {
            // ////console.log('jumbo asignado',jumbo);
            // ////console.log('registro a actualizar',registro);

            this.actualizar_registro(jumbo, registro);
            if (jumbo.lote.tipo_lotes_id == 2) {
                await this.cargarJumbosReprocesoPorAsignar();
            }
        });

        //se usa cuando se crea un jumbo que ya existe pero que no esta asignado a ningun registro de resultado_analisis
        Event.$on('actualizar_jumbo', async (jumbo, registro) => {
            this.actualizar_registro(jumbo, registro);
            if (jumbo.lote.tipo_lotes_id == 2) {
                await this.cargarJumbosReprocesoPorAsignar();
            }
        });

        Event.$on('lote_creado', (lote) => {
            Event.$emit('nuevo_lote', lote);
        });

        // Event.$on('actualizar_comentario',(registro)=>{
        //     this.actualizar_comentario(registro);
        // });
    },
    methods: {
        parseIfString(value) {
            if (typeof value !== 'string') return value;

            const trimmed = value.trim();
            if (trimmed === '') return value;

            const num = Number(trimmed);
            if (isNaN(num)) return value;

            return Number.isInteger(num) ? parseInt(trimmed, 10) : parseFloat(trimmed);
        },
        abrirModalComentario(registro, parametro) {
            // ////console.log('registro',registro);
            // ////console.log('parametro',parametro);
            this.$emit('abrir_modal_comentario_parametro', registro, parametro);
        },

        async actualizar_comentario(registro) {
            let registro_tabla = await this.buscarRegistroPorID(registro.id_registro);
            registro_tabla = registro;
        },

        async actualizar_comentario_analisis(registro) {
            let registro_tabla = await this.buscarRegistroPorID(registro.id_registro);
            registro_tabla = registro;
        },
        getColor(color, subcolumna) {
            // ////console.log('subcolumna',subcolumna);
            if (color != null) {
                if (subcolumna != null) {
                    if (subcolumna.key == 'fecha' || subcolumna.key == 'hora') {
                        return {};
                    } else {
                        return {
                            "background-color": color.valor,
                            "color": "#000000"
                        };
                    }
                } else {
                    return {
                        "background-color": color.valor,
                        "color": "#000000"
                    };
                }
            }
        },

        marcar_color(registro) {
            Event.$emit('abrir_seleccionar_color', registro);
        },

        async actualizar_color(registro) {
            let registro_tabla = await this.buscarRegistroPorID(registro.id);
            registro_tabla['color'] = registro.color;
        },

        async actualizar_registro(jumbo, registro) {
            //this.mostrarLoading('Actualizando Registro...')
            this.mostrarLoading({ titulo: 'Actualizando Registro...', color: 'green' })
            ////console.log("ingreso in");
            //recibe el jumbo creado y el registro al cual se le asignará el jumbo
            let url = `${this.base_url}resultados/${registro.id_registro}`;
            let body = {
                jumbos_id: jumbo.id
            };
            await this.axios.put(url, body, this.headers).then(async (response) => {
                let registro_tabla = await this.buscarRegistroPorID(registro.id_registro);

                let reg = response.data.data;
                if (reg.jumbos_id != null) {
                    registro_tabla['nombre_lote'] = reg.jumbo.lote.nombre_lote;
                    registro_tabla['nro_jumbo'] = reg.jumbo.nro_jumbo;
                    registro_tabla['jumbos_id'] = reg.jumbos_id;
                    if (reg.jumbo.viene_del_jumbo != null) {
                        //el jumbo proviene de otro jumbo
                        registro_tabla['proviene_de'] = {
                            jumbo: reg.jumbo.proveniente_de.nro_jumbo,
                            lote: reg.jumbo.proveniente_de.lote.nombre_lote,
                            texto: reg.jumbo.proveniente_de_texto
                        };
                    } else {
                        registro_tabla['proviene_de'] = null;
                    }
                }
                // ////console.log('registro_tabla',registro_tabla);
                // ////console.log('nuevos_ registros_actualizados',this.registros);
                // ////console.log('ultimos registros actualizados',this.ultimos_registros);
                this.ocultarLoading();
            }).catch((error) => {
                ////console.log('error', error);
                this.ocultarLoading();
                this.mostrarLoading({ titulo: error, color: 'red' })
            });
        },
        async asignar_jumbo(registro, accion) {
            Event.$emit('abrir_modal_jumbo', registro, accion);
            // ////console.log('registro a asignar jumbo',registro);
        },
        async crear_jumbo() {
            //this.mostrarLoading('Agregando Fila...')
            this.mostrarLoading({ titulo: 'Agregando Fila...', color: 'green' })

            //buscar el ultimo numero de control planta (numero correlativo y sumarle 1 para crear el analisis_detalle)
            let url = `${this.base_url}resultado_analisis/ultimo_control_planta/${this.punto_medicion.id}`;
            let ultimo_control = null;
            let crear = false;
            await this.axios.get(url, this.headers).then((response) => {
                
                //se obtuvo el ultimo correlativo
                ultimo_control = response.data.data;
                if (ultimo_control == null) {
                    ultimo_control = 0;
                }
                crear = true;
            }).catch((error) => {
                ////console.log('error', error);
            });


            if (crear){
                await this.agregarFila(ultimo_control);
            }
                // ////console.log('ultimo control planta',ultimo_control);
        },
        restriccion(valor) {
            // ////console.log('valor_recibido',valor);
            if (valor != '') {
                if (valor.includes('R')) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        async agregarFila(ultimo_control = null) {
            // ////console.log('ultimo control recibido',ultimo_control);
            //this.mostrarLoading('Agregando Fila...');
            this.mostrarLoading({ titulo: 'Agregando Fila...', color: 'green' })

            //////console.log('agregando...fila');
            let registro_nuevo = {
                id_registro: '',
                jumbos_id: null,
            };
            await this.obtenerSubColumnasInicio.forEach(sub => {
                registro_nuevo[sub.key] = '';
            });

            await this.obtenerSubColumnasFinal.forEach(sub => {
                registro_nuevo[sub.key] = '';
            });

            await this.obtenerParametros.forEach(par => {
                registro_nuevo[par.id] = {
                    id: '',
                    resultado_analisis_id: registro_nuevo.id_registro,
                    parametro_detalles_id: par.id,
                    nombre_parametro: par.nombre_parametro,
                    equipos_procesos_id: par.equipos_procesos_id,
                    nombre_equipo: par.nombre_equipo,
                    cantidad_decimales: par.cantidad_decimales,
                    valor: '',
                    observacion: '',
                    numero_alarmas: 0
                };
            });

            await this.crearNuevoAnalisis(registro_nuevo, ultimo_control);
        },

        async crearNuevoAnalisis(registro_nuevo, ultimo_control) {
            let url = `${this.base_url}resultados`;
            let body = {
                fecha: this.moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                punto_mediciones_id: this.punto_medicion.id
            };
            if (ultimo_control != null) {
                // se esta creando un jumbo
                body['control_planta_prefijo'] = this.punto_medicion.prefijo_jumbo;
                body['control_planta_correlativo'] = ultimo_control + 1;
            }
            await this.axios.post(url, body, this.headers).then(async (response) => {
                //se crea nuevo resultado de analisis
                let reg = response.data.data;
                registro_nuevo.id_registro = reg.id;
                let fecha = new Date(reg.fecha);
                registro_nuevo.fecha = this.moment(fecha).format('YYYY-MM-DD');
                registro_nuevo.hora = this.moment(fecha).format('H:mm');
                registro_nuevo.fecha_hora = fecha;
                registro_nuevo.color = reg.color;
                registro_nuevo.analista_id = reg.analista;
                registro_nuevo.muestreador_id = reg.muestreador;
                registro_nuevo.jefe_turno_id = reg.jefe_turno;
                if (reg.control_planta_prefijo) {
                    registro_nuevo['control_planta'] = `${reg.control_planta_prefijo}${reg.control_planta_correlativo}`;
                    registro_nuevo.proviene_de = null;
                }
                //rellenar los datos de jumbo en caso de que se haya agregado un nuevo jumbo
                if (response.data.data.jumbo != null) {
                    // registro_nuevo.control_plata = `${reg.control_planta_prefijo}${reg.control_planta_correlativo}`;
                    // registro_nuevo.nombre_lote = response.data.data.jumbo.lote.nombre_lote;
                    // registro_nuevo.nro_jumbo = response.data.data.jumbo.nro_jumbo;

                    // //comprobando si el nuevo jumbo proviene de otro jumbo (para mostrar la info visualmente)
                    // if(response.data.data.jumbo.viene_del_jumbo!=null){
                    //     registro_nuevo.proviene_de = {
                    //         lote:response.data.data.jumbo.proveniente_de.lote.nombre_lote,
                    //         jumbo:response.data.data.jumbo.proveniente_de.nro_jumbo,
                    //     };
                    // }
                }

                /**=========================== SECCION COMENTADA QUE REGISTRABA VALOR 0 EN EL PRIMER PARAMETRO DE RESULTADO ANALISIS */
                //agregando un registro detalles (con valor null), para que no se pierda el registro 
                //en caso de que no se haya registrado ningun parámetro (se toma el primer parámetro del punto de medición)
                // let parametros_punto_medicion = this.obtenerParametros;
                // let body = {
                //     parametro_detalles_id:parametros_punto_medicion[0].id,
                //     resultado_analisis_id:response.data.data.id,
                //     valor:0
                // };
                // let url = `${this.base_url}resultado_detalles`;
                // await this.axios.post(url,body,this.headers).then((response)=>{
                //     let registro = this.buscarRegistroPorID(response.data.data.resultado_analisis_id);
                //     if(registro!=undefined){
                //         registro[response.data.data.parametro_detalles_id].id = response.data.data.id;
                //         registro[response.data.data.parametro_detalles_id].valor = response.data.data.valor;
                //     }
                // }).catch((error)=>{
                //     ////console.log('error',error);
                // });
                /**=========================== SECCION COMENTADA QUE REGISTRABA VALOR 0 EN EL PRIMER PARAMETRO DE RESULTADO ANALISIS */


                if (this.registros.length > 0) {
                    //si el array de registros nuevos ya tiene una fila, se saca y se agrega al array de ultimos registros
                    this.ultimos_registros.unshift(this.registros[0])
                    this.registros = []
                };
                this.registros.push(registro_nuevo);
                this.ocultarLoading();
                //emitir evento para desbloquear el agregar fila (se creó el nuevo registro correctamente)
                Event.$emit('desbloquear_agregar_fila');
            }).catch((error) => {
                //emitir evento para desbloquear el agregar fila (hubo algún error no se pudo crear el nuevo registro)
                Event.$emit('desbloquear_agregar_fila');
                this.ocultarLoading();
            });
        },
        async guardarColumnaResultadoAnalisis(registro, subcolumna) {
            ////console.log('subcolumna', subcolumna, 'registro', registro);

            let url = `${this.base_url}resultados/${registro.id_registro}`;
            let body = {
            };
            if (subcolumna.tipo == 'select') {
                let valor = registro[subcolumna.key].id;
                body[subcolumna.key] = valor;
            }
            if (subcolumna.tipo == 'autocomplete') {
                body[subcolumna.key] = registro[subcolumna.key];
            }
            if (subcolumna.tipo == 'radio') {
                let valor = registro[subcolumna.key] == true ? 1 : 0;
                body[subcolumna.key] = valor;
            }

            if (subcolumna.tipo == 'texto' && subcolumna.key != 'nro_jumbo' && subcolumna.key != 'control_planta') {
                body[subcolumna.key] = registro[subcolumna.key];
            }
            if (subcolumna.key == 'fecha' || subcolumna.key == 'hora') {
                //si se esta editando la fecha o la hora
                registro.hora = registro.hora.replace(",", ":").replace(".", ":").replace("-", ":").replace("/", ":").replace("+", ":").replace("*", ":");
                //si se esta editando la fecha o la hora
                let fechita = this.moment(new Date()).add(1, 'h').format('YYYY-MM-DD HH:mm');
                let registro_fecha = this.moment(registro.fecha + " " + registro.hora).format('YYYY-MM-DD HH:mm');
                if (registro_fecha > fechita) {
                    this.mostrarLoading({ titulo: `Fecha ingresada ${registro_fecha} es mayor a fecha actual...`, color: 'red' })
                    return;
                }
                ////console.log("fecha", registro.fecha, "hora", registro.hora);
                body['fecha'] = `${registro.fecha} ${registro.hora}`;
            }
            if (subcolumna.key == 'control_planta') {
                /**separación del prefijo con el correlativo */
                body['control_planta_correlativo'] = registro[subcolumna.key].substring(3, Infinity);
            }
            if (subcolumna.key == 'nombre_lote') {
                //consultando el resultado analisis original
                let resultado = await this.consultar_resultado_analisis(registro.id_registro);
                if (registro['nombre_lote'] != '') {
                    //consultar si existe el lote
                    let lote = await this.consultar_lote(registro[subcolumna.key]);
                    if (lote == null) {
                        //mostrar mensaje de lote inexistente (obtener el valor anterior de lote)
                        this.mensaje_alert = `El Lote N° ${registro[subcolumna.key]} no existe, debe crearlo para utilizarlo`;
                        this.tipo_alert = 'error';
                        this.mostrar_alert = true;

                        //restableciendo datos
                        registro.nombre_lote = resultado.jumbo.lote.nombre_lote;
                        registro.nro_jumbo = resultado.jumbo.nro_jumbo;
                    } else {
                        //consultando si existe algun jumbo que tenga el mismo lotes_id y numero de jumbo
                        let jumbo = await this.consultar_combinacion(lote.id, registro['nro_jumbo']);
                        if (jumbo != null) {
                            //consultar si el (id) del jumbo encontrado es el mismo que tiene actualmente el registro
                            //obtener el resultado_analisis
                            let resultado = await this.consultar_resultado_analisis(registro.id_registro);
                            if (jumbo.id == resultado.jumbos_id) {
                                //no se debe hacer nada ya que es el jumbo actual del registro
                            } else {

                                //consultar si existe algun registro que tenga el id del jumbo
                                let resultado_existente = this.consultar_resultado_analisis_por_jumbos_id(jumbo.id);
                                if (resultado_existente != null) {
                                    //indicar que ya existe un registro con el jumbo que se indica (se debe restablecer el valor del lote)
                                    // ////console.log('ya existe un registro con el lote y numero de jumbo');
                                    this.mensaje_alert = `Ya existe un registro con el Lote N° ${lote.nombre_lote} y Maxisaco N° ${jumbo.nro_jumbo}`;
                                    this.mostrar_alert = true;
                                    this.tipo_alert = 'error';
                                    // ////console.log('restableciendo datos',resultado);
                                    registro.nombre_lote = resultado.jumbo.lote.nombre_lote;
                                    registro.nro_jumbo = resultado.jumbo.nro_jumbo;
                                }
                            }
                        }
                    }
                } else {
                    //restablecer datos
                    registro.nombre_lote = resultado.jumbo.lote.nombre_lote;
                    registro.nro_jumbo = resultado.jumbo.nro_jumbo;
                }

            }

            //comprobando el jumbo
            if (subcolumna.key == 'nro_jumbo') {
                // ////console.log("se esta editando el jumbo");
                //consultando el resultado analisis original
                let resultado = await this.consultar_resultado_analisis(registro.id_registro);

                //buscar el lote del registro
                if (registro['nro_jumbo'] != "") {
                    let lote = await this.consultar_lote(registro['nombre_lote']);
                    if (lote != null) {
                        //consultando si existe algun jumbo que tenga el mismo lotes_id y numero de jumbo
                        let jumbo = await this.consultar_combinacion(lote.id, registro['nro_jumbo']);
                        // ////console.log('jumbo consultado',jumbo);
                        if (jumbo == null) {
                            //no hay ningun jumbo con el lote y numero de jumbo que se esta actualizando

                            //actualizar el numero del jumbo del registro

                            if (resultado != null) {
                                let jumbo_a_actualizar = await this.consultar_jumbo(resultado.jumbos_id);
                                let url = `${this.base_url}jumbos/${jumbo_a_actualizar.id}`;
                                let body = {
                                    lotes_id: jumbo_a_actualizar.lotes_id,
                                    nro_jumbo: registro['nro_jumbo']
                                };
                                await this.axios.put(url, body, this.headers).then((response) => {
                                    // ////console.log('se ha actualizado el jumbo',response.data);
                                }).catch((error) => {
                                    ////console.log('error', error);
                                });
                                // ////console.log('jumbo a actualizar',jumbo_a_actualizar);
                                // ////console.log('body actualizar jumbo',body);
                            }
                        } else {
                            // ya existe un jumbo con el lote y numero de jumbo indicado
                            // consultando a que registro de resultado analisis corresponde el jumbo
                            let resultado_existente = await this.consultar_resultado_analisis_por_jumbos_id(jumbo.id);
                            // ////console.log('resultado_analisis',resultado_existente);
                            if (resultado_existente != null && jumbo.id != resultado.jumbos_id) {
                                //mostrar mensaje de que ya existe un registro con el jumbo indicado
                                this.mensaje_alert = `Ya existe un registro con el Lote N° ${lote.nombre_lote} y Maxisaco N° ${jumbo.nro_jumbo}`;
                                this.mostrar_alert = true;
                                this.tipo_alert = 'error';

                                //restableciendo datos
                                // ////console.log('restableciendo datos',resultado);
                                registro.nombre_lote = resultado.jumbo.lote.nombre_lote;
                                registro.nro_jumbo = resultado.jumbo.nro_jumbo;
                            } else if (resultado_existente == null) {
                                //no existe ningun registro con el id del jumbo
                                //actualizar el id del jumbo del registro analisis (el jumbo si existe pero no esta asociado a un registro)
                                let url = `${this.base_url}resultados/${resultado.id}`;
                                let body = {
                                    jumbos_id: jumbo.id
                                };
                                await this.axios.put(url, body, this.headers).then((response) => {
                                    // ////console.log('se ha actualizado el id del jumbo del registro',response);
                                    //actualizar información del jumbo (en caso de que provenga de otro jumbo)
                                    if (response.data.data.jumbo.viene_del_jumbo != null) {
                                        registro.proviene_de = {
                                            lote: response.data.data.jumbo.proveniente_de.lote.nombre_lote,
                                            jumbo: response.data.data.jumbo.proveniente_de.nro_jumbo,
                                            texto: response.data.data.jumbo.proveniente_de_texto
                                        };
                                    }
                                }).catch((error) => {
                                    ////console.log('error', error);
                                })
                            }
                            // ////console.log('no se puede actualizar el numero de jumbo');
                        }
                    }
                    // ////console.log('lote jumbo',lote);
                } else {
                    //restablecer los datos
                    registro.nombre_lote = resultado.jumbo.lote.nombre_lote;
                    registro.nro_jumbo = resultado.jumbo.nro_jumbo;
                }

            }

            //obtiene el largo de un objeto
            let keys_body = Object.keys(body).length;


            //se envia la peticion solo si el largo del body es mayor a 0 (que tiene datos)
            if (keys_body > 0) {
                await this.axios.put(url, body, this.headers).then(async (response) => {
                    // ////console.log('respuestaaaaaaaaaaaaa',response.data.data.id);
                    if (subcolumna.key == 'viene_del_jumbo') {
                        let resultado = await this.buscarRegistroPorID(response.data.data.id);
                        // ////console.log('resultado',resultado);
                        let proviene_de = null
                        if (response.data.data.jumbo.proveniente_de) {
                            proviene_de = {
                                lote: response.data.data.jumbo.proveniente_de.lote.nombre_lote,
                                jumbo: response.data.data.jumbo.proveniente_de.nro_jumbo,
                                texto: response.data.data.jumbo.proveniente_de_texto
                            }
                        }

                        this.$set(resultado, 'proviene_de', proviene_de);

                        /**actualizando jumbos reproceso disponibles */
                        await this.cargarJumbosReprocesoPorAsignar();
                        // resultado.proviene_de = {
                        //     lote:response.data.data.jumbo.proveniente_de.lote.nombre_lote,
                        //     jumbo:response.data.data.jumbo.proveniente_de.nro_jumbo
                        // }
                        //////console.log('resultado',resultado);

                    }

                    if (subcolumna.key == 'lotes_id') {
                        //////console.log('lotes_id actualizado',response.data);
                        let resultado = await this.buscarRegistroPorID(response.data.data.id);
                        // ////console.log('resultado',resultado);
                        if (response.data.data.lote) {
                            this.$set(resultado, 'total_kilos_lote', response.data.data.lote.total_kg);
                        }
                    }
                    //////console.log('Resultado analisis actualizado',response.data);
                }).catch((error) => {
                    ////console.log('error', error);
                    this.mostrarLoading({ titulo: (error.message ? error.message : error), color: 'red' });
                });
            }



            //////console.log('body',body);

            //////console.log('registro',valor,subcolumna);
        },

        async cargarJumbosReprocesoPorAsignar() {
            //this.mostrarLoading('Cargando Maxisacos a Reproceso sin asignar');
            this.mostrarLoading({ titulo: 'Cargando Maxisacos a Reproceso sin asignar', color: 'green' })

            let url = `${this.base_url}jumbos_repaso/por_asignar`;
            let jumbos_reproceso = [];
            await this.axios.get(url, this.headers).then((response) => {
                jumbos_reproceso = response.data.data;
                jumbos_reproceso.unshift({ id: '', lote_jumbo: 'No Proviene' });
                this.ajustes.columnas_inicio[4].subcolumnas[0].opciones = jumbos_reproceso;
                this.ocultarLoading();
            }).catch((error) => {
                ////console.log('error', error);
                this.ocultarLoading();
            });
        },

        async consultar_lote(nombre_lote) {
            let lote = null;
            await this.axios.get(`${this.base_url}lote/nombre_lote/${nombre_lote}`, this.headers).then((response) => {
                // ////console.log('respuesta de lote',response);
                lote = response.data.lote;
            }).catch((error) => {
                ////console.log('error', error);
            });
            return lote;
        },

        async consultar_jumbo(jumbo_id) {
            let jumbo = null;
            let url = `${this.base_url}jumbos/${jumbo_id}`;
            await this.axios.get(url, this.headers).then((response) => {
                jumbo = response.data.data;
            }).catch((error) => {
                ////console.log('error', error);
            });
            return jumbo;
        },

        async consultar_combinacion(lote_id, nro_jumbo) {
            let jumbo = null;
            await this.axios.get(`${this.base_url}jumbo/lotes_id/${lote_id}/nro_jumbo/${nro_jumbo}`, this.headers).then((response) => {
                // ////console.log('respuesta de jumbo',response);
                jumbo = response.data.jumbo;
            }).catch((error) => {
                ////console.log('error', error);
            });
            return jumbo;
        },

        async consultar_resultado_analisis(id) {
            let resultado = null;
            let url = `${this.base_url}resultados/${id}`;
            await this.axios.get(url, this.headers).then((response) => {
                // ////console.log('resultado_analisis',response);
                resultado = response.data.data;
            }).catch((error) => {
                ////console.log('error', error);
            });
            return resultado;
        },

        async consultar_resultado_analisis_por_jumbos_id(jumbos_id) {
            let resultado = null;
            let url = `${this.base_url}resultados/jumbos_id/${jumbos_id}`;
            await this.axios.get(url, this.headers).then((response) => {
                // ////console.log('resultado_analisis_jumbos_id',response);
                resultado = response.data.data;
            }).catch((error) => {
                ////console.log('error', error);
            });
            return resultado;
        },


        async registrar_detalle_select(registro, parametro) {
            /**esta funcion solo es utilizada por los parametros de tipo select select */

            if (registro[parametro.id].id == '') {
                /*nuevo registro */
                let url = `${this.base_url}resultado_detalles`;
                let body = {
                    resultado_analisis_id: registro.id_registro,
                    parametro_detalles_id: registro[parametro.id].parametro_detalles_id,
                    valor: registro[parametro.id].valor
                };

                this.axios.post(url, body, this.headers).then(async (response) => {

                    let registro = this.buscarRegistroPorID(response.data.data.resultado_analisis_id);
                    if (registro != undefined) {
                        registro[response.data.data.parametro_detalles_id].id = response.data.data.id;
                        registro[response.data.data.parametro_detalles_id].numero_alarmas = response.data.data.numero_alarmas;
                    }
                }).catch((error) => {
                    ////console.log('error', error);
                });

            } else {
                /**actualizar registro */
                let id_detalle = registro[parametro.id].id;
                let url = `${this.base_url}resultado_detalles/${id_detalle}`;
                let body = {
                    valor: registro[parametro.id].valor

                };
                await this.axios.put(url, body, this.headers).then((response) => {

                }).catch((error) => {
                    ////console.log('error', error);
                });
            }
            // ////console.log('registro',registro);
            // ////console.log('parametro',parametro);
        },

        async registrar_detalle(reef, registro, columna, tipo) {

            if (registro[columna.id].valor != '') {

                let string = registro[columna.id].valor.toString();
                let num = string.replace(",", ".");
                // ////console.log('num',num);
                let valor = Number(num);
                let mensaje = '';
                let registrar = true;

                let continuar = true;
                /*verificar si el valor es distinto al valor original del registro */
                if (registro[columna.id].id != '') {
                    let url = `${this.base_url}resultado_detalles/${registro[columna.id].id}`;
                    await this.axios.get(url, this.headers).then((res) => {
                        // ////console.log('valor original',Number(res.data.data.valor));
                        if (valor == Number(res.data.data.valor)) {
                            continuar = false;
                        }
                    }).catch((error) => {
                        ////console.log('error', error);
                    });
                }

                if (!continuar) {
                    return;
                }
                /**comprobar si hay alguna configuracion de alarma para el parametro */
                if (columna.alarma_1 != null || columna.alarma_2 != null) {
                    // ////console.log('si entra');

                    // ////console.log('valor',valor);
                    // ////console.log('parametro', columna);


                    /**comprobar si estan ambos valores configurados */
                    if (columna.alarma_1 != null && columna.alarma_2 != null) {
                        /*estan configuradas ambas alarmas */

                        /**PASO 1: comprobar si es un entre */
                        if (columna.signo_1 == '>=' && columna.signo_2 == '<=' && Number(columna.alarma_2) > Number(columna.alarma_1)) {
                            //el valor de la alarma esta entre un rango establecido
                            if (valor >= columna.alarma_1 && valor <= columna.alarma_2) {
                                // alert('el valor ingresado esta entre los valores de alarma (es un entre)');
                                mensaje = `El valor ${valor} esta entre los valores de alarma (${columna.alarma_1} y ${columna.alarma_2}) del parámetro ( alarma 1  y alarma 2) `;
                                registrar = false;
                            } else {
                                // ////console.log('registrar (entretejidos)');
                            }
                        } else if (columna.signo_1 == '>=' && columna.signo_2 == '<=' && Number(columna.alarma_2) < Number(columna.alarma_1)) {
                            /**PASO 2: comprobar si se excede el limite maximo o minimo de cada valor de alarma*/
                            /*(se utiliza este else if para el caso de la grasa, que no es un rango de valores, sino son independientes) */
                            if (columna.signo_1 == '>=') {
                                /*ver si el valor es superior al valor de alarma 1 */
                                if (valor >= columna.alarma_1) {
                                    // alert('el valor es superior al valor de alarma 1');
                                    mensaje = `El valor ${valor} es superior al valor (${columna.alarma_1}) de alarma 1`;
                                    registrar = false;
                                } else {
                                    // ////console.log('independiente no es superior alarma 1');
                                }
                            }
                            if (columna.signo_1 == '<=') {
                                /*ver si el valor es inferior al valor de alarma 1*/
                                if (valor <= columna.alarma_1) {
                                    // alert('el valor es inferior al valor de alarma 1');
                                    mensaje = `El valor ${valor} es inferior al valor (${columna.alarma_1}) de alarma 1`;
                                    registrar = false;
                                } else {
                                    // ////console.log('independiente no es inferior alarma 1');
                                }
                            }
                            if (columna.signo_2 == '>=') {
                                /*ver si el valor es superior al valor de alarma 2 */
                                if (valor >= columna.alarma_2) {
                                    // alert('el valor es superior al valor de alarma 2');
                                    mensaje = `El valor ${valor} es superior al valor (${columna.alarma_2}) de alarma 2`;
                                    registrar = false;
                                } else {
                                    // ////console.log('independiente no es superior alarma 2');
                                }
                            }
                            if (columna.signo_2 == '<=') {
                                /*ver si el valor es inferior al valor de alarma 2 */
                                if (valor <= columna.alarma_2) {
                                    // alert('el valor es inferior al valor de alarma 2');
                                    mensaje = `El valor ${valor} es inferior al valor (${columna.alarma_2}) de alarma 2`;
                                    registrar = false;
                                } else {
                                    // ////console.log('independiente no es inferior alarma 1');
                                }
                            }
                        }

                        /*debo comprobar sin usar else if (tal vez) */

                    } else if (columna.alarma_1 != null && columna.alarma_2 == null) {
                        // ////console.log('entra a solo alarma 1');
                        /**solo esta configurada la alarma 1 */
                        if (columna.signo_1 == '>=') {
                            /*ver si el valor es superior al valor de alarma 1 */
                            if (valor >= columna.alarma_1) {
                                // alert('el valor es superior al valor de (alarma 1)');
                                mensaje = `El valor ${valor} es superior al valor (${columna.alarma_1}) de alarma 1`;
                                registrar = false;
                            }
                        } else if (columna.signo_1 == '<=') {
                            /*ver si el valor es inferior al valor de alarma 1*/
                            if (valor <= columna.alarma_1) {
                                // alert('el valor es inferior al valor de (alarma 1)');
                                mensaje = `El valor ${valor} es inferior al valor (${columna.alarma_1}) de alarma 1`;
                                registrar = false;
                            }
                        }

                    } else if (columna.alarma_2 != null && columna.alarma_1 == null) {
                        // ////console.log('entra a solo alarma 2');
                        /**solo esta configurada la alarma 2 */
                        if (columna.signo_2 == '>=') {
                            /*ver si el valor es superior al valor de alarma 2 */
                            if (valor >= columna.alarma_2) {
                                // alert('el valor es superior al valor de (alarma 2)');
                                mensaje = `El valor ${valor} es superior al valor (${columna.alarma_2}) de alarma 2`;
                                registrar = false;
                            }
                        } else if (columna.signo_2 == '<=') {
                            /*ver si el valor es inferior al valor de alarma 2 */
                            if (valor <= columna.alarma_2) {
                                // alert('el valor es inferior al valor de (alarma 2)');
                                mensaje = `El valor ${valor} es inferior al valor (${columna.alarma_2}) de alarma 2`;
                                registrar = false;
                            }
                        }
                    }

                    /**se comprueba si hay alguna alarma que se excedio */
                    if (!registrar) {
                        /*enviar mensaje de alarma a usuario para su confirmación */
                        this.$refs.confirm.open('Confirmar', mensaje, { color: 'red' }).then((confirmacion) => {

                            if (!confirmacion) {
                                /**restablecer los datos del registro */
                                if (registro[columna.id].id != '') {
                                    /**si tiene un registro por tanto restablecer valor */
                                    let url = `${this.base_url}resultado_detalles/${registro[columna.id].id}`;
                                    this.axios.get(url, this.headers).then((response) => {
                                        // ////console.log('resultado analisis a restablecer: ',response.data.data);
                                        registro[columna.id].valor = this.redondear(response.data.data.valor, 1);
                                        this.$refs[`${reef}`][0].focus();
                                    }).catch((error) => {
                                        ////console.log('error', error);
                                    });
                                }
                                /* else{
                                    registro[columna.id].valor = '';
                                } */
                            } else {
                                /**se confirmo el valor por el usuario */
                                let alarma_enviada = false;
                                if (registro[columna.id].id != '') {
                                    //es una actualización
                                    //////console.log('es una actualización',registro,columna,tipo);
                                    let id_detalle = registro[columna.id].id;
                                    let url = `${this.base_url}resultado_detalles/${id_detalle}`;
                                    let body = {
                                        // valor:registro[columna.id].valor
                                        valor: valor
                                    };
                                    this.axios.put(url, body, this.headers).then(async (response) => {
                                        ////console.log('registro_detalle_actualizado_alarma: ', response.data.data);
                                        let registro = this.buscarRegistroPorID(response.data.data.resultado_analisis_id);
                                        ////console.log('existe la wa', registro)
                                        if (registro != undefined) {

                                            registro[response.data.data.parametro_detalles_id].id = response.data.data.id;
                                            registro[response.data.data.parametro_detalles_id].numero_alarmas = response.data.data.numero_alarmas;
                                        }
                                        // alarma_enviada = await this.Enviar_Alarma(response.data.data);
                                        // registro[columna.id].numero_alarmas = 1;
                                        this.$refs[`${reef}`][0].focus();
                                    }).catch((error) => {
                                        ////console.log('error', error);
                                        //this.ocultarLoading()
                                    });
                                } else {
                                    //es un nuevo registro
                                    let url = `${this.base_url}resultado_detalles`;
                                    let body = {
                                        resultado_analisis_id: registro.id_registro,
                                        parametro_detalles_id: registro[columna.id].parametro_detalles_id,
                                        // valor:registro[columna.id].valor
                                        valor: valor
                                    };
                                    //////console.log('body',body);
                                    this.axios.post(url, body, this.headers).then(async (response) => {
                                        ////console.log('registro creado', response.data);
                                        let registro = this.buscarRegistroPorID(response.data.data.resultado_analisis_id);
                                        ////console.log('registro', registro);

                                        if (registro != undefined) {
                                            registro[response.data.data.parametro_detalles_id].id = response.data.data.id;
                                            registro[response.data.data.parametro_detalles_id].numero_alarmas = response.data.data.numero_alarmas;
                                        }
                                        // alarma_enviada = await this.Enviar_Alarma(response.data.data);
                                        this.$refs[`${reef}`][0].focus();
                                        //this.ocultarLoading()
                                        //////console.log('registro hecho y actualizado',this.registros);
                                    }).catch((error) => {
                                        ////console.log('error', error);
                                        //this.ocultarLoading()
                                    });
                                }
                            }
                        });
                    } else {
                        /*registrar el valor normalmente */
                        if (registro[columna.id].id != '') {
                            //es una actualización
                            //////console.log('es una actualización',registro,columna,tipo);
                            let id_detalle = registro[columna.id].id;
                            let url = `${this.base_url}resultado_detalles/${id_detalle}`;
                            let body = {
                                // valor:registro[columna.id].valor
                                valor: valor
                            };
                            await this.axios.put(url, body, this.headers).then((response) => {
                                //////console.log('registro_detalle_actualizado',response.data);
                                let registro = this.buscarRegistroPorID(response.data.data.resultado_analisis_id);
                                if (registro != undefined) {
                                    registro[response.data.data.parametro_detalles_id].numero_alarmas = response.data.data.numero_alarmas;
                                }
                                //this.ocultarLoading()
                            }).catch((error) => {
                                ////console.log('error', error);
                                //this.ocultarLoading()
                            });
                        } else {
                            //es un nuevo registro
                            let url = `${this.base_url}resultado_detalles`;
                            let body = {
                                resultado_analisis_id: registro.id_registro,
                                parametro_detalles_id: registro[columna.id].parametro_detalles_id,
                                // valor:registro[columna.id].valor
                                valor: valor
                            };
                            // ////console.log('deberia entrar qui');
                            //////console.log('body',body);
                            await this.axios.post(url, body, this.headers).then((response) => {
                                //////console.log('registro guardado paso comprobacion alarma',response.data);
                                //////console.log('acá llega la wa',response.data.data)
                                let registro = this.buscarRegistroPorID(response.data.data.resultado_analisis_id);
                                //////console.log('el regisrito1',registro)
                                if (registro != undefined) {
                                    registro[response.data.data.parametro_detalles_id].id = response.data.data.id;
                                    registro[response.data.data.parametro_detalles_id].numero_alarmas = response.data.data.numero_alarmas;
                                }

                                if (response.data.resultados_anteriores.length > 0) {
                                    this.rellenarProrrateoAutomatico(response.data.resultados_anteriores, columna.nombre_parametro);
                                }
                                //this.ocultarLoading()
                                //////console.log('registro hecho y actualizado',this.registros);
                            }).catch((error) => {
                                ////console.log('error', error);
                                //this.ocultarLoading()
                            });
                        }
                    }
                }
                else {

                    /**entra aqui en caso de que el parámetro no tenga configurada alarmas */

                    //funcion que permite registrar o actualizar un resultado_detalle
                    if (registro[columna.id].id != '') {
                        //es una actualización
                        //////console.log('es una actualización',registro,columna,tipo);
                        let id_detalle = registro[columna.id].id;
                        let url = `${this.base_url}resultado_detalles/${id_detalle}`;
                        let body = {
                            // valor:registro[columna.id].valor
                            valor: valor
                        };
                        await this.axios.put(url, body, this.headers).then((response) => {
                            //////console.log('registro_detalle_actualizado',response.data);
                            //this.ocultarLoading()
                        }).catch((error) => {
                            ////console.log('error', error);
                            //this.ocultarLoading()
                        });
                    } else {
                        //es un nuevo registro
                        let url = `${this.base_url}resultado_detalles`;
                        let body = {
                            resultado_analisis_id: registro.id_registro,
                            parametro_detalles_id: registro[columna.id].parametro_detalles_id,
                            // valor:registro[columna.id].valor
                            valor: valor
                        };
                        // ////console.log('deberia entrar qui');
                        //////console.log('body',body);
                        await this.axios.post(url, body, this.headers).then((response) => {
                            ////console.log('registro guardado sin alarma', response.data);
                            let registro = this.buscarRegistroPorID(response.data.data.resultado_analisis_id);
                            if (registro != undefined) {
                                registro[response.data.data.parametro_detalles_id].id = response.data.data.id;
                            }


                            //this.ocultarLoading()
                            //////console.log('registro hecho y actualizado',this.registros);
                        }).catch((error) => {
                            ////console.log('error', error);
                            //this.ocultarLoading()
                        });
                    }
                }
                //this.mostrarLoading('Guardando...')

            } else {
                ////console.log(registro[columna.id].id);
                await this.$refs.confirm.open('Confirmar', 'Desea eliminar valor a ', { color: 'red' }).then((confirmacion) => {
                    if (confirmacion) {
                        let body = { _method: "DELETE" }
                        this.axios.post(`${this.base_url}resultado_detalles/${registro[columna.id].id}`, body, this.headers).then((res) => {
                            ////console.log(res);
                        }).catch((e) => {
                            this.errorMessage(e, "Error al grabar despacho ");
                        });
                    } else {
                        if (registro[columna.id].id != '') {
                            /**si tiene un registro por tanto restablecer valor */
                            let url = `${this.base_url}resultado_detalles/${registro[columna.id].id}`;
                            this.axios.get(url, this.headers).then((response) => {
                                registro[columna.id].valor = this.redondear(response.data.data.valor, 1);
                            }).catch((error) => {
                                ////console.log('error', error);
                            });
                        }
                    }
                });
            }

            // ////console.log('registrandooo...');
            // ////console.log('registro',registro);
            //////console.log('columna',columna);
            //////console.log('tipo',tipo);
        },

        async Enviar_Alarma(resultado_detalle) {
            let url = `${this.base_url}alerta_enviada`;
            let body = {
                resultado_detalles_id: resultado_detalle.id,
                valor: resultado_detalle.valor,
            };
            await this.axios.post(url, body, this.headers).then((response) => {
                // ////console.log('alarma_enviada',response);
                return true;
            }).catch((error) => {
                ////console.log('error', error);
                return false;
            });
        },

        rellenarProrrateoAutomatico(resultados, parametro) {
            this.registros_prorrateados = [];
            // ////console.log('parametro',columna.nombre_parametro);
            resultados.forEach(detalle => {
                let registro = this.buscarRegistroPorID(detalle.resultado_analisis_id);
                if (registro != undefined) {
                    registro[detalle.parametro_detalles_id].id = detalle.id;
                    registro[detalle.parametro_detalles_id].valor = this.redondear(detalle.valor, 1);
                    this.registros_prorrateados.push({ 'fecha': registro.fecha, 'hora': registro.hora, 'parametro': parametro, 'valor': this.redondear(detalle.valor, 1) });
                }
            });
        },

        async rellenarUltimosRegistros() {
            //por cada registro hago un nuevo registro para agregarlo al array ultimos_registros
            await this.ultimos_registros_recibidos.forEach(async (reg) => {
                //////console.log('registro',reg);
                let registro = {
                    id_registro: reg.id,
                    jumbos_id: reg.jumbos_id
                };
                ////console.log(reg);
                //agregando columnas de fecha y hora (materia prima si fuese linea)
                await this.obtenerSubColumnasInicio.forEach(sub => {
                    registro[sub.key] = '';
                });
                //agregando columnas de analista, muestreador y jefe turno
                await this.obtenerSubColumnasFinal.forEach(sub => {
                    registro[sub.key] = '';
                });
                //seteando la fecha y hora que viene del registro
                registro.fecha = this.moment(reg.fecha).format('YYYY-MM-DD');
                registro.hora = this.moment(reg.fecha).format('H:mm');
                registro.fecha_hora = reg.fecha;
                registro.observacion = reg.observacion;
                registro.tipo_mps_id = reg.tipo_mp;
                registro.analista_id = reg.analista;
                registro.muestreador_id = reg.muestreador;
                registro.jefe_turno_id = reg.jefe_turno;
                registro.color = reg.color;
                registro.vobo = reg.vobo == 1 ? true : false;
                registro.lotes_id = reg.lote;
                registro.patente = reg.patente;
                registro.total_kilos_lote = reg.lote ? reg.lote.total_kg : '';
                registro.barrido = reg.barrido ? reg.barrido : 0;
                //agregando control planta para el caso de los resultado análisis de los jumbos
                if (reg.control_planta_prefijo) {
                    registro.control_planta = `${reg.control_planta_prefijo}${reg.control_planta_correlativo}`;
                    registro.proviene_de = null;
                    if (reg.jumbo != null) {
                        registro.nombre_lote = reg.jumbo.lote.nombre_lote;
                        registro.nro_jumbo = reg.jumbo.nro_jumbo;

                        if (reg.jumbo.viene_del_jumbo != null) {
                            ////console.log('entro al proviene de de ultimos registros', reg);
                            registro.viene_del_jumbo = reg.jumbo.proveniente_de.id;
                            registro.proviene_de = {
                                lote: reg.jumbo.proveniente_de.lote.nombre_lote,
                                jumbo: reg.jumbo.proveniente_de.nro_jumbo,
                                texto: reg.jumbo.proveniente_de_texto
                            };
                        }
                        registro.movimiento = null;
                        if (reg.jumbo.movimientos_id != null) {
                            // ////console.log('entro al movimiento del maxi',reg);
                            registro.movimiento = reg.jumbo.movimientos_id;
                            registro.movimiento_fecha = reg.jumbo.movimientos.fecha != null ? this.moment(reg.jumbo.movimientos.fecha).format('DD-MM-YYYY') : '';
                        }
                    }
                }

                //agregando los parametros del punto de medición
                await this.obtenerParametros.forEach(par => {
                    ////console.log('par',par);
                    registro[par.id] = {
                        id: '',
                        resultado_analisis_id: '',
                        parametro_detalles_id: par.id,
                        nombre_parametro: par.nombre_parametro,
                        equipos_procesos_id: par.equipos_procesos_id,
                        nombre_equipo: par.nombre_equipo,
                        cantidad_decimales: par.cantidad_decimales,
                        valor: '',
                        observacion: '',
                        numero_alarmas: ''
                    };
                });

                //asignando los valores de los registros de resultado_detalles
                await reg.resultado_detalles.forEach(detalle => {
                    // console.log('parametro_detalles_id',registro[detalle.parametro_detalles_id]);
                    //se cambió a esta forma para evitar el error cannot set id of undefined

                    if (registro[detalle.parametro_detalles_id]) {
                        let cantidad_decimales = registro[detalle.parametro_detalles_id].cantidad_decimales
                        registro[detalle.parametro_detalles_id] = {
                            id: detalle.id,
                            resultado_analisis_id: detalle.resultado_analisis_id,
                            parametro_detalles_id: detalle.parametro_detalles_id,
                            valor: this.redondear(detalle.valor, cantidad_decimales),
                            observacion: detalle.observacion,
                            numero_alarmas: detalle.numero_alarmas
                        };
                    }

                    //version anterior de setear los campos (parametros) del registro que ya se encuentran registrados
                    // registro[detalle.parametro_detalles_id]['id'] = detalle.id;
                    // registro[detalle.parametro_detalles_id]['resultado_analisis_id'] = detalle.resultado_analisis_id;
                    // registro[detalle.parametro_detalles_id]['parametro_detalles_id'] = detalle.parametro_detalles_id;
                    // registro[detalle.parametro_detalles_id]['valor'] = detalle.valor;
                });

                // ////console.log('registro original',reg);

                this.ultimos_registros.push(registro);
            });

            // ////console.log('ultimos registros ordenados',this.ultimos_registros);
        },

        redondear(value, precision) {
            var multiplier = Math.pow(10, precision || 0);
            // ////console.log(`numero redondeado: ${Math.round(value * multiplier) / multiplier}`);
            return Math.round(value * multiplier) / multiplier;
        },

        buscarRegistroPorID(id) {
            let registro;
            registro = this.registros.find(reg => {
                return reg.id_registro == id;
            });
            //buscando el registro entre los ultimos registros
            if (registro == undefined) {
                registro = this.ultimos_registros.find(reg => {
                    return reg.id_registro == id;
                });
            }
            //////console.log('registro_encontrado',registro);
            return registro;
        },

        marcar_color_optimo(parametro, registro, index) {
            /**recibe el parametro y el registro */

            let marcar = false;
            let valor = registro[parametro.id].valor;
            if (valor == '' || valor == null) {
                return false;
            }

            if (typeof (valor) == 'string' && valor.length > 0) {
                valor = parseFloat(Number(valor).toFixed(4));

            } else if (typeof (valor) == 'string' && valor.length == 0) {
                valor = null
            }

            let optimo_minimo = typeof parametro.optimo_minimo == 'string' ? parseFloat(Number(parametro.optimo_minimo).toFixed(4)) : parametro.optimo_minimo;
            let optimo_maximo = typeof parametro.optimo_maximo == 'string' ? parseFloat(Number(parametro.optimo_maximo).toFixed(4)) : parametro.optimo_maximo;

            //aqui puede que este el BUG
            if ((optimo_minimo && optimo_maximo) || (optimo_minimo == 0 && optimo_maximo)) {


                // ////console.log('valor', valor);
                if (valor >= optimo_minimo && valor <= optimo_maximo) {
                    marcar = true;
                    // ////console.log('parametro optimo',parametro);
                    // ////console.log('registro optimo',registro);
                }
            }
            return marcar;
        },

        marcar_color_optimo_maximo(parametro, registro, index) {
            /**recibe el parametro y el registro */

            let marcar = false;
            let valor = registro[parametro.id].valor;
            if (valor == '' || valor == null) {
                return false;
            }

            if (typeof (valor) == 'string' && valor.length > 0) {
                valor = parseFloat(Number(valor).toFixed(4));

            } else if (typeof (valor) == 'string' && valor.length == 0) {
                valor = null
            }
            let optimo_maximo = typeof parametro.optimo_maximo == 'string' ? parseFloat(Number(parametro.optimo_maximo).toFixed(4)) : parametro.optimo_maximo;

            //aqui puede que este el BUG
            if (optimo_maximo) {


                // ////console.log('valor', valor);
                if (valor > optimo_maximo) {
                    marcar = true;
                    // ////console.log('parametro optimo',parametro);
                    // ////console.log('registro optimo',registro);
                }
            }
            return marcar;
        },

        marcar_alarma_minima(parametro, registro) {
            return registro[parametro.id].valor < parametro.alarma_minimo && parametro.alarma_minimo != null && registro[parametro.id].valor != '' ? true : false;
        },
        marcar_alarma_maxima(parametro, registro) {
            return registro[parametro.id].valor <= parametro.alarma_maximo && parametro.alarma_maximo != null && registro[parametro.id].valor != '' && registro[parametro.id].valor >= parametro.alarma_minimo ? true : false;
        },

        abrirObservacion(registro) {

        },

        cerrar_alert() {
            this.mensaje_alert = '';
            this.tipo_alert = 'info';
            this.mostrar_alert = false;
        },

        borrarRegistrosProrrateados() {
            this.registros_prorrateados = [];
        },

        async asignar_rapido(registro) {
            this.lock_rayo = true
            let body = { id: registro.id_registro }
            await this.axios.post(`${this.base_url}asignar_maxi_rapido`, body, this.headers).then((res) => {
                //////console.log('asignar_rapido', res.data);
                let jumbo = res.data.data.jumbo;
                if (jumbo != null) {
                    this.actualizar_registro(jumbo, registro);
                    //////console.log('si se hizo')
                } else {
                    this.mostrarLoading({ titulo: res.data.message, color: 'red' })
                }
                this.lock_rayo = false
            }).catch(e => {
                this.lock_rayo = false
                //////console.log(e);
            });
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading']),
    },
    computed: {
        ...mapState({
            base_url: state => state.base_url,
            headers: state => state.headers,
            permisos: state => state.permisos_prod
        }),
        nuevosRegistrosFormulasCalculadas() {
            //////console.log('calculando en computed');
            this.obtenerParametros.forEach(par => {
                if (par.formula.length > 0) {
                    this.registros.forEach(registro => {
                        let resultado;
                        let parametro_vacio = false;
                        par.formula.forEach(paso => {
                            //por cada paso de la formula hago el calculo
                            let num1, num2;
                            //obteniendo el primer valor
                            if (paso.valor1 == 'numero') {
                                //es un numero
                                num1 = this.parseIfString(paso.parametro_detalles_id1);
                            } else if (paso.valor1 == 'anterior') {
                                //se toma el valor del paso anterior
                                num1 = this.parseIfString(resultado);
                            } else if (paso.valor1 == 'indicador') {
                                //es un valor que debo tomar del registro
                                num1 = this.parseIfString(registro[paso.parametro_detalles_id1].valor);
                                if (num1 == '') {
                                    parametro_vacio = true;
                                }
                            }

                            //obteniendo el segundo valor
                            if (paso.valor2 == 'numero') {
                                //es un numero
                                num2 = this.parseIfString(paso.parametro_detalles_id2);
                            } else if (paso.valor2 == 'anterior') {
                                //se toma el valor del paso anterior
                                num2 = this.parseIfString(resultado);
                            } else if (paso.valor2 == 'indicador') {
                                //es un valor que debo tomar del registro
                                num2 = this.parseIfString(registro[paso.parametro_detalles_id2].valor);
                                //si es un indicador y no tiene un valor asignado, retornar resultado = ""
                                if (num2 == '') {
                                    parametro_vacio = true;
                                }
                            }

                            if (paso.operador == '-') {
                                resultado = num1 - num2;
                            } else if (paso.operador == '/') {
                                resultado = num1 / num2;
                            }
                        });
                        if (parametro_vacio) {
                            //hay un parametro que aun no tiene un valor numérico
                            registro[par.id].valor = '';
                        } else {
                            registro[par.id].valor = resultado.toFixed(1);
                        }
                        // registro[par.id].valor = resultado.toFixed(1);
                    });
                }
            });
            return this.registros;
        },
        ultimosRegistrosFormulasCalculadas() {
            //////console.log('calculando en computed');
            this.obtenerParametros.forEach(par => {
                if (par.formula.length > 0) {
                    this.ultimos_registros.forEach(registro => {
                        let resultado;
                        let parametro_vacio = false;
                        par.formula.forEach(paso => {
                            //por cada paso de la formula hago el calculo
                            let num1, num2;
                            //obteniendo el primer valor
                            if (paso.valor1 == 'numero') {
                                //es un numero
                                num1 = this.parseIfString(paso.parametro_detalles_id1);

                            } else if (paso.valor1 == 'anterior') {
                                //se toma el valor del paso anterior
                                num1 = this.parseIfString(resultado);
                            } else if (paso.valor1 == 'indicador') {
                                //es un valor que debo tomar del registro
                                num1 = this.parseIfString(registro[paso.parametro_detalles_id1].valor);
                                //si es un indicador y no tiene un valor asignado, retornar resultado = ""
                                if (num1 === '') {
                                    parametro_vacio = true;
                                }
                            }

                            //obteniendo el segundo valor
                            if (paso.valor2 == 'numero') {
                                //es un numero
                                num2 = this.parseIfString(paso.parametro_detalles_id2);
                            } else if (paso.valor2 == 'anterior') {
                                //se toma el valor del paso anterior
                                num2 = this.parseIfString(resultado);
                            } else if (paso.valor2 == 'indicador') {
                                //es un valor que debo tomar del registro
                                num2 = this.parseIfString(registro[paso.parametro_detalles_id2].valor);
                                //si es un indicador y no tiene un valor asignado, retornar resultado = ""
                                if (num2 === '') {
                                    parametro_vacio = true;
                                }
                            }

                            if (paso.operador == '-') {
                                resultado = num1 - num2;
                            } else if (paso.operador == '/') {
                                resultado = num1 / num2;
                            }
                        });

                        if (parametro_vacio) {
                            //hay un parametro que aun no tiene un valor numérico
                            registro[par.id].valor = '';
                        } else {
                            registro[par.id].valor = resultado.toFixed(1);
                        }
                    });
                }
            });
            // ////console.log('ultimos registros con formula calculada',this.ultimos_registros);
            return this.ultimos_registros;
        },
        obtenerSubColumnasInicio() {
            let subcolumnas_inicio = [];
            this.ajustes.columnas_inicio.forEach(columna => {
                columna.subcolumnas.forEach(subcolumna => {
                    subcolumnas_inicio.push(subcolumna);
                });
            });
            //////console.log('columnas_inicio',subcolumnas_inicio);
            return subcolumnas_inicio;
        },
        obtenerSubColumnasFinal() {
            let subcolumnas_final = [];
            this.ajustes.columnas_final.forEach(columna => {
                columna.subcolumnas.forEach(subcolumna => {
                    subcolumnas_final.push(subcolumna);
                });
            });
            return subcolumnas_final;
        },
        obtenerEquipos() {
            let equipos = [];
            this.ajustes.tipos.forEach(tipo => {
                tipo.equipos.forEach(equipo => {
                    equipos.push(equipo);
                });
            });
            return equipos;
        },
        obtenerParametros() {
            let parametros = [];
            this.ajustes.tipos.forEach(tipo => {
                tipo.equipos.forEach(equipo => {
                    equipo.parametros.forEach(par => {
                        //console.log('parametro', par);
                        parametros.push(par);
                    });
                });
            });
            return parametros;
        },
        numeroSubColumnas() {
            let num = 0;
            this.ajustes.tipos.forEach(tipo => {
                tipo.equipos.forEach(equipo => {
                    equipo.parametros.forEach(par => {
                        num++;
                    });
                });
            });
            this.ajustes.columnas_final.forEach(columna => {
                columna.subcolumnas.forEach(subcolumna => {
                    num++;
                });
            });
            this.ajustes.columnas_inicio.forEach(columna => {
                columna.subcolumnas.forEach(subcolumna => {
                    num++;
                });
            });
            return num;
        },
        editables() {
            /* let rolep = this.permisos.find( p=>p.name.includes('Jefe Produccion') );
            if (rolep) {
                ////console.log("rol Produccion nop")
                this.es_prod = false;
            } else {
                ////console.log("rol Produccion yep")
                this.es_prod = true;
            } */
            let role = this.permisos.find(p => p.name.includes('Analista'));
            if (role) {  /* FALSE NO BLOQUEA, TRUE BLOQUEA  */
                ////console.log("rol Analista yep")
                return false;
            } else {
                ////console.log("rol Analista nop")
                return true;
            }
        },
    },
    components: {
        'modal-jumbo': Modal_Jumbo,
        'modal-color': Modal_Seleccion_Color,
        'modal-comentario-parametro': Modal_Comentario_Parametro,
        'confirm': Confirm
    },
}
</script>
<style scoped>
input {
    color: #000000;
}

.barridos-1 {
    background-color: #b2dfdb;
}

.fila_separadora {
    height: 22px;
    background: #CFD8DC;
}

.border {
    border: 1px solid #333;
    border-collapse: collapse;
}

.hidden {
    display: none;
}

/* estilos de tabla */
.table-box {
    width: 100%;
    height: 100%;
    overflow: auto;
    border: 1px solid;
    /*box-shadow: 0 10px 100px rgba(0,0,0,0.5);*/
}

@media screen and (min-height: 481px) {
    .table-box {
        height: 100%;
        height: calc(100vh - 240px) !important;
    }
}

@media screen and (max-height: 480px) {
    .table-box {
        height: 280px;
        height: calc(100vh - 140px) !important;
    }
}


table {
    border-spacing: 0px;
    display: inline-table;
    /*key*/
}

tr:nth-child(even) {
    /* background-color: #f2f2f2; */
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;

}

th {
    padding: 0px 0px;
    min-width: 80px;
    max-width: 120px;
    /*puse el height para indicar el alto de los th */
    height: 38px;
}

td {
    /* padding:1px 1px;
    margin: 0px; */
    border: 0.1px solid #37474F;
    /* border-bottom: 0.4px solid #ddd; */
}

table tbody tr td {
    text-align: center;
    padding: 0.001em 0.2em;
}

/*segunda fila de header*/
.z-index-1 {
    left: 0px;
    z-index: 4;
}

.z-index-2 {
    /*left: 150px;*/
    left: 80px;
    z-index: 4;
}

.z-index-3 {
    left: 240px;
    z-index: 4;
}

/*segunda fila de header*/

/* .z-index-action-1{
    z-index:1; 
    top: 0px;
}

.z-index-action-2{
    z-index:1; 
    top: 34px;
} */

.td_con_icono {
    min-width: 100px !important;
    text-align: left !important;
}

thead th:first-child {
    left: 0;
    z-index: 4;
}

thead th.header-0 {
    position: -webkit-sticky;
    /* for Safari */
    position: sticky;
    padding: 0px 0px;
    background-color: #2e7d32;
    color: #fff;
    font-size: 1em;
    line-height: 1.3;
}

thead th.header-1 {
    position: -webkit-sticky;
    /* for Safari */
    position: sticky;
    padding: 0px 0px;
    background-color: #2e7d32;
    color: #fff;
    top: 0px;
    font-size: 1em;
    line-height: 1.3;
}

thead th.header-2 {
    position: -webkit-sticky;
    /* for Safari */
    position: sticky;
    padding: 0px 0px;
    background-color: #2e7d32;
    color: #fff;
    /*top: 34px;*/
    top: 40px;
    font-size: 1em;
    line-height: 1.3;
}

/*capa mas baja del header de la tabla*/
.z-index-header {
    z-index: 1;
}



/*td columna 1, columna2, columna3*/
.fixed-left-1 {
    left: 0px;
    position: -webkit-sticky;
    /*for safary*/
    position: sticky;
    background-color: #2e7d32;
    color: #fff;
    z-index: 3;
}

.fixed-left-2 {
    /*left:150px;*/
    left: 80px;
    position: -webkit-sticky;
    /*for safary*/
    position: sticky;
    background-color: #2e7d32;
    color: #fff;
    z-index: 3;
}

.fixed-left-3 {
    left: 240px;
    position: -webkit-sticky;
    /*for safary*/
    position: sticky;
    background-color: #2e7d32;
    color: #fff;
    z-index: 3;
}

/*marcan una fila de color*/
.tr-red {
    background-color: rgba(244, 67, 54, 0.65);
    color: #fff;
}

.tr-warning {
    background-color: rgba(255, 193, 7, 0.65);
    color: #333;
}

.tr-success {
    background: #7CB342;
    color: #fff
}

/*marcar una columna de color */
.limite_alto {
    background-color: rgba(244, 67, 54, 0.65);
    color: #ffffff;
}

.limite_bajo {
    background-color: #F57F17;
    color: #ffffff;
}

/**colores para input de alarma,optimo minimo y máximo */
.color_optimo {
    background-color: #DCEDC8;
}

.color_alarma {
    background-color: #EF9A9A;
}

/* .alarma_minima{
    background-color: #BBDEFB;
}

.alarma_maxima{
    background-color: #EF9A9A;
} */
.fuente {
    color: #000;
}

.v-input__control {
    min-height: 32px !important;
}

input[type=number] {
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 70px;
    padding: 1px 1px;
    margin-left: 0.2em;
    margin-right: 0.1em;
    border: 1.2px solid #212121;
    -moz-appearance: textfield;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=text] {
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 80px;
    padding: 2px 2px;
    border: 1.2px solid #212121;
}

select {
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 120px;
    padding: 3px 3px;
}

input[type=datetime-local] {
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 120px;
    padding: 2px 2px;
}

input:focus {
    border: 1px solid #BBDEFB;
    border-radius: 3px;
}

/**media queries para el alto de la tabla */
@media screen and (max-height: 600px) {
    .table-box {
        height: 370px;
    }
}

@media screen and (max-height: 768px) {
    .table-box {
        height: 420px;
    }
}

@media screen and (min-height: 769px) {
    .table-box {
        height: 720px;
    }
}
</style>